import { Box } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import MarkdownRender from '../../components/Document/markdownRender';
import Seo from '../../components/Seo';
import ProcessMarkdown from '../../lib/processMarkdown';

const V3Documentation = () => {
  const version4 = ProcessMarkdown(`v4.html`);
  const version3 = ProcessMarkdown(`v3.html`);
  const version5 = ProcessMarkdown(`v5.html`);

  if (
    version4.headers.length !== 0 &&
    version3.headers.length !== 0 &&
    version5.headers.length !== 0
  ) {
    return (
      <>
        <Seo seo={{}} />
        <Box
          width={'100%'}
          p={0}
          m={0}
          bg={'#1a1f36'}
          textColor={'#c1c9d2'}
          overflow={'hidden'}
        >
          <MarkdownRender
            version4={version4}
            version3={version3}
            version5={version5}
          />
        </Box>
      </>
    );
  }
};

export default V3Documentation;
